export const getDefaultBotName = (organizationName) => {
  const organization = String(organizationName || "Plist").trim();

  return `${organization.charAt(0).toUpperCase()}${organization.slice(1)} AI Concierge`;
};
